/**
 * Quick view panel (#quickshop, snippets/quickshop-container.liquid): the theme fetches the product
 * page, renames .m6pr to .m6pr-compact and drops the section into the panel (custom-async.js,
 * quickShop). Our product page CSS matches both classes; the scripts that enhance that markup are
 * re-run here every time the panel gets new content.
 */
import { initJudgemeBadge } from './judgeme-badge.js';
import { initVariantScroll } from './variant-scroll.js';

export function initQuickshop() {
  const panel = document.getElementById('quickshop');
  if (!panel) return;
  new MutationObserver(() => {
    initJudgemeBadge(panel);
    initVariantScroll(panel);
  }).observe(panel, { childList: true });
}
